// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.trainings-page {
  max-width: 1500px;
  margin: 40px auto 20px auto;
}

.trainings-admin-section {
  margin-bottom: 32px;
}

.add-training-btn {
  font-size: 16px;
  padding: 14px 28px;
  box-shadow: 0 2px 8px rgba(0, 102, 204, 0.2);
}

.training-form-container {
  background: white;
  border-radius: 12px;
  padding: 16px 24px; /* 16px góra/dół, 24px lewo/prawo */
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
  margin-bottom: 24px;
}

.training-form-container h3 {
  margin-bottom: 20px;
  color: #333;
}

.training-form .form-row {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 16px;
  margin-bottom: 16px;
}

.training-form .form-group {
  margin-bottom: 0;
}

.training-form textarea {
  width: 100%;
  padding: 12px;
  border: 1px solid #ddd;
  border-radius: 8px;
  resize: vertical;
  font-family: inherit;
}

.attachments-editor {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  align-items: center;
}

.attachments-editor .attachment-item {
  display: flex;
  align-items: center;
  gap: 8px;
  background: #f0f4f8;
  padding: 6px 12px;
  border-radius: 20px;
  font-size: 13px;
}

.attachment-editor-name {
  display: inline-flex;
  align-items: center;
  gap: 6px;
}

.attachments-editor .attachment-item button {
  background: none;
  border: none;
  cursor: pointer;
  color: #999;
  font-size: 14px;
}

.attachments-editor .attachment-item button:hover {
  color: #dc3545;
}

.attachment-buttons {
  display: flex;
  gap: 8px;
  margin-top: 8px;
  width: 100%;
}

.form-actions {
  display: flex;
  gap: 12px;
  margin-top: 20px;
}

.trainings-content {
  display: flex;
  flex-direction: column;
  gap: 40px;
}

.trainings-section {
  background: white;
  border-radius: 16px;
  padding: 32px;
  box-shadow: 0 2px 12px rgba(0,0,0,0.08);
}

.section-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 28px;
  padding-bottom: 20px;
  border-bottom: 2px solid #f0f0f0;
}

.section-header h3 {
  font-size: 24px;
  color: #1a1a1a;
  margin: 0;
  font-weight: 600;
}

.section-count {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  padding: 8px 18px;
  border-radius: 20px;
  font-size: 14px;
  font-weight: 600;
}

.archive-section .section-count {
  background: linear-gradient(135deg, #868f96 0%, #596164 100%);
}

/* Single Column Layout */
.trainings-grid {
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.trainings-grid.archive {
  gap: 20px;
}

/* Modern Training Card - Full Width */
.training-card {
  background: white;
  border-radius: 16px;
  overflow: hidden;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow: 0 2px 8px rgba(0,0,0,0.08);
  border: 1px solid #e8e8e8;
  position: relative;
}

.training-card:hover {
  box-shadow: 0 8px 24px rgba(0,0,0,0.12);
  transform: translateY(-4px);
}

.training-card.past {
  opacity: 0.92;
}

.training-card.cancelled {
  background: #fff8f8;
  border-color: #ffcdd2;
}

.training-card.cancelled::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 6px;
  background: linear-gradient(135deg, #eb3349 0%, #f45c43 100%);
  border-radius: 16px 16px 0 0;
}

/* Card Content Wrapper */
.card-content-wrapper {
  display: flex;
  gap: 32px;
  padding: 28px;
}

/* Logo Container */
.training-logo-container {
  flex: 0 0 200px;
  height: 160px;
  background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  box-shadow: 0 4px 12px rgba(0,0,0,0.08);
}

.training-logo-img {
  max-width: 90%;
  max-height: 90%;
  object-fit: contain;
}

/* Main Content Area */
.training-main-content {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  gap: 20px;
}

/* Header Row */
.training-header-row {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 20px;
}

.training-title-section {
  flex: 1 1;
}

.training-title {
  font-size: 24px;
  font-weight: 700;
  color: #1a1a1a;
  margin: 0 0 12px 0;
  line-height: 1.3;
}

.departments-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.dept-tag {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  padding: 6px 14px;
  border-radius: 16px;
  font-size: 12px;
  font-weight: 600;
}

/* Action Buttons */
.training-actions {
  display: flex;
  gap: 8px;
  flex-shrink: 0;
}

.action-btn {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 10px 16px;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  transition: all 0.2s;
}

.action-btn .btn-text {
  display: inline;
}

.edit-btn {
  background: #e3f2fd;
  color: #1976d2;
}

.edit-btn:hover {
  background: #1976d2;
  color: white;
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(25, 118, 210, 0.3);
}

.cancel-btn {
  background: #fff3e0;
  color: #f57c00;
}

.cancel-btn:hover {
  background: #f57c00;
  color: white;
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(245, 124, 0, 0.3);
}

.delete-btn {
  background: #ffebee;
  color: #d32f2f;
}

.delete-btn:hover {
  background: #d32f2f;
  color: white;
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(211, 47, 47, 0.3);
}

/* Meta Information Grid */
.training-meta-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 16px;
  padding: 20px;
  background: #f8f9fa;
  border-radius: 12px;
}

.meta-item {
  display: flex;
  align-items: center;
  gap: 12px;
}

.meta-icon {
  display: inline-flex;
  color: #667eea;
  flex-shrink: 0;
}

.meta-icon svg {
  width: 24px;
  height: 24px;
  stroke-width: 1.8;
}

.meta-content {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.meta-label {
  font-size: 11px;
  text-transform: uppercase;
  color: #888;
  font-weight: 600;
  letter-spacing: 0.5px;
}

.meta-value {
  font-size: 14px;
  color: #333;
  font-weight: 500;
}

/* Description Section */
.training-description-section {
  padding: 20px;
  background: linear-gradient(135deg, #f5f7fa 0%, #e8eef5 100%);
  border-left: 4px solid #667eea;
  border-radius: 10px;
  box-shadow: 0 2px 6px rgba(102, 126, 234, 0.1);
}

.description-heading {
  font-size: 15px;
  font-weight: 700;
  color: #667eea;
  margin: 0 0 12px 0;
  display: flex;
  align-items: center;
  gap: 8px;
}

.description-heading svg {
  width: 19px;
  height: 19px;
  flex-shrink: 0;
  stroke-width: 1.8;
}

.training-description {
  color: #2d3748;
  font-size: 15px;
  line-height: 1.8;
  margin: 0;
  white-space: pre-wrap;
}

/* Resources Section */
.training-resources {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

/* Primary Links */
.primary-links {
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
}

.primary-link {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 14px 24px;
  border-radius: 10px;
  text-decoration: none;
  font-size: 15px;
  font-weight: 600;
  transition: all 0.3s;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
}

.primary-link .link-arrow {
  margin-left: 4px;
  transition: transform 0.2s;
}

.primary-link:hover .link-arrow {
  transform: translateX(4px);
}

.meeting-link {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
}

.meeting-link:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 16px rgba(102, 126, 234, 0.4);
}

.recording-link {
  background: linear-gradient(135deg, #f093fb 0%, #f5576c 100%);
  color: white;
}

.recording-link:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 16px rgba(245, 87, 108, 0.4);
}

/* Attachments Section */
.attachments-section {
  padding: 20px;
  background: #f8f9fa;
  border-radius: 12px;
}

.attachments-heading {
  font-size: 14px;
  font-weight: 600;
  color: #333;
  margin: 0 0 12px 0;
}

.attachments-list {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
  gap: 10px;
}

.attachment-item {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 12px 16px;
  background: white;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  text-decoration: none;
  color: #333;
  transition: all 0.2s;
}

.attachment-item:hover {
  border-color: #667eea;
  background: #f0f4ff;
  transform: translateX(4px);
}

.attachment-icon {
  display: inline-flex;
  color: #667eea;
}

.attachment-name {
  flex: 1 1;
  font-size: 14px;
  font-weight: 500;
}

.attachment-download {
  color: #667eea;
  font-weight: bold;
}

/* Empty State */
.empty-state {
  text-align: center;
  padding: 60px 24px;
  color: #666;
}

.empty-state.small {
  padding: 32px;
}

.empty-icon {
  font-size: 64px;
  margin-bottom: 20px;
}

.trainings-page .empty-icon svg {
  width: 64px;
  height: 64px;
  color: #667eea;
  stroke-width: 1.5;
}

.empty-state h4 {
  margin-bottom: 12px;
  color: #333;
  font-size: 20px;
}

.empty-state p {
  margin-bottom: 20px;
  font-size: 15px;
}

/* Responsive Design */
@media (max-width: 900px) {
  .card-content-wrapper {
    flex-direction: column;
  }

  .training-logo-container {
    flex: 0 0 auto;
    width: 100%;
    height: 200px;
  }

  .training-meta-grid {
    grid-template-columns: 1fr;
  }

  .training-header-row {
    flex-direction: column;
  }

  .training-actions {
    width: 100%;
    justify-content: flex-start;
  }

  .action-btn .btn-text {
    display: none;
  }

  .action-btn {
    padding: 10px 12px;
  }

  .attachments-list {
    grid-template-columns: 1fr;
  }
}

/* Logo Section Styles */
.logo-section {
  margin-bottom: 20px;
}

.current-logo-preview {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 12px;
  padding: 12px;
  background: #f8f9fa;
  border-radius: 8px;
  border: 1px solid #e0e0e0;
}

.current-logo-preview img {
  width: 80px;
  height: 60px;
  object-fit: cover;
  border-radius: 6px;
}

.btn-remove-logo {
  background: #ffeeee;
  color: #dc3545;
  border: 1px solid #dc3545;
  padding: 6px 12px;
  border-radius: 6px;
  cursor: pointer;
  font-size: 13px;
  transition: all 0.2s;
}

.btn-remove-logo:hover {
  background: #dc3545;
  color: white;
}

.logo-options {
  display: flex;
  gap: 12px;
  margin-bottom: 12px;
  flex-wrap: wrap;
}

.upload-btn {
  cursor: pointer;
}

.upload-btn:hover {
  background: #0056b3;
  color: white;
}

.logo-gallery {
  background: #f8f9fa;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  padding: 16px;
  margin-bottom: 12px;
}

.logo-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(100px, 1fr));
  gap: 12px;
}

.logo-item {
  position: relative;
  cursor: pointer;
  border: 3px solid transparent;
  border-radius: 8px;
  overflow: hidden;
  transition: all 0.2s;
  aspect-ratio: 4/3;
}

.logo-item:hover {
  border-color: #0066cc;
  transform: scale(1.05);
}

.logo-item.selected {
  border-color: #28a745;
}

.logo-item img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.no-logos {
  color: #666;
  text-align: center;
  padding: 20px;
  font-style: italic;
}

.manual-url-input {
  margin-top: 8px;
}

.manual-url-input label {
  display: block;
  font-size: 13px;
  color: #666;
  margin-bottom: 4px;
}

.manual-url-input input {
  width: 100%;
  padding: 10px;
  border: 1px solid #ddd;
  border-radius: 6px;
  font-size: 14px;
}

/* Multi-select Departments Styles */
.departments-multiselect {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  padding: 12px;
  background: #f8f9fa;
  border: 1px solid #ddd;
  border-radius: 8px;
}

.department-checkbox {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 12px;
  background: white;
  border: 1px solid #ddd;
  border-radius: 20px;
  cursor: pointer;
  font-size: 13px;
  transition: all 0.2s;
}

.department-checkbox:hover {
  border-color: #0066cc;
  background: #f0f7ff;
}

.department-checkbox.selected {
  background: #0066cc;
  border-color: #0066cc;
  color: white;
}

.department-checkbox input {
  display: none;
}

.selected-departments {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-top: 8px;
  padding: 8px 12px;
  background: #e8f4fd;
  border-radius: 6px;
  font-size: 13px;
}

.selected-departments span {
  flex: 1 1;
  color: #0066cc;
}

.btn-clear-depts {
  background: none;
  border: none;
  color: #dc3545;
  cursor: pointer;
  font-size: 12px;
}

.btn-clear-depts:hover {
  text-decoration: underline;
}

.hint {
  font-weight: normal;
  color: #888;
  font-size: 12px;
}

/* Modal Styles */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.modal-content {
  background: white;
  padding: 24px;
  border-radius: 12px;
  max-width: 400px;
  width: 90%;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.2);
}

.modal-content h4 {
  margin: 0 0 8px 0;
  color: #333;
}

.modal-hint {
  color: #666;
  font-size: 13px;
  margin-bottom: 16px;
}

.modal-content input {
  width: 100%;
  padding: 12px;
  border: 1px solid #ddd;
  border-radius: 8px;
  font-size: 14px;
  margin-bottom: 16px;
}

.modal-content input:focus {
  outline: none;
  border-color: #0066cc;
}

.modal-field {
  margin-bottom: 16px;
}

.modal-field label {
  display: block;
  font-weight: 500;
  margin-bottom: 6px;
  color: #333;
  font-size: 13px;
}

.modal-field input,
.modal-field select {
  width: 100%;
  padding: 10px 12px;
  border: 1px solid #ddd;
  border-radius: 8px;
  font-size: 14px;
  margin-bottom: 0;
}

.modal-field select {
  background: white;
  cursor: pointer;
}

.url-modal {
  max-width: 450px;
}

.modal-actions {
  display: flex;
  gap: 12px;
  justify-content: flex-end;
}

@media (max-width: 768px) {
  .logo-grid {
    grid-template-columns: repeat(auto-fill, minmax(80px, 1fr));
  }

  .departments-multiselect {
    gap: 6px;
  }

  .department-checkbox {
    padding: 4px 10px;
    font-size: 12px;
  }

  .training-form .form-row {
    grid-template-columns: 1fr;
  }

  .trainings-section {
    padding: 20px;
  }

  .section-header h3 {
    font-size: 20px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/css/Trainings.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,4CAA4C;AAC9C;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB,EAAE,mCAAmC;EACvD,qCAAqC;EACrC,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,eAAe;EACf,WAAW;AACb;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,uCAAuC;AACzC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,eAAe;EACf,cAAc;EACd,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,6DAA6D;AAC/D;;AAEA,yBAAyB;AACzB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,SAAS;AACX;;AAEA,sCAAsC;AACtC;EACE,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,iDAAiD;EACjD,sCAAsC;EACtC,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,uCAAuC;EACvC,2BAA2B;AAC7B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,WAAW;EACX,6DAA6D;EAC7D,4BAA4B;AAC9B;;AAEA,yBAAyB;AACzB;EACE,aAAa;EACb,SAAS;EACT,aAAa;AACf;;AAEA,mBAAmB;AACnB;EACE,eAAe;EACf,aAAa;EACb,6DAA6D;EAC7D,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,uCAAuC;AACzC;;AAEA;EACE,cAAc;EACd,eAAe;EACf,mBAAmB;AACrB;;AAEA,sBAAsB;AACtB;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA,eAAe;AACf;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,QAAQ;EACR,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,2BAA2B;EAC3B,4CAA4C;AAC9C;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,2BAA2B;EAC3B,4CAA4C;AAC9C;;AAEA,0BAA0B;AAC1B;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,oBAAoB;EACpB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,yBAAyB;EACzB,WAAW;EACX,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,gBAAgB;AAClB;;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb,6DAA6D;EAC7D,8BAA8B;EAC9B,mBAAmB;EACnB,8CAA8C;AAChD;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,SAAS;EACT,qBAAqB;AACvB;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,qCAAqC;AACvC;;AAEA;EACE,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,6DAA6D;EAC7D,YAAY;AACd;;AAEA;EACE,2BAA2B;EAC3B,+CAA+C;AACjD;;AAEA;EACE,6DAA6D;EAC7D,YAAY;AACd;;AAEA;EACE,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,qBAAqB;EACrB,WAAW;EACX,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,oBAAoB;EACpB,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA,gBAAgB;AAChB;EACE,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,eAAe;AACjB;;AAEA,sBAAsB;AACtB;EACE;IACE,sBAAsB;EACxB;;EAEA;IACE,cAAc;IACd,WAAW;IACX,aAAa;EACf;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,WAAW;IACX,2BAA2B;EAC7B;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,0BAA0B;EAC5B;AACF;;AAEA,wBAAwB;AACxB;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;EACzB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,6BAA6B;EAC7B,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;AACjB;;AAEA,oCAAoC;AACpC;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,iBAAiB;EACjB,sBAAsB;EACtB,mBAAmB;EACnB,eAAe;EACf,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,SAAO;EACP,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,eAAe;AACjB;;AAEA,iBAAiB;AACjB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,UAAU;EACV,0CAA0C;AAC5C;;AAEA;EACE,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;EACX,eAAe;AACjB;;AAEA;;EAEE,WAAW;EACX,kBAAkB;EAClB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,yBAAyB;AAC3B;;AAEA;EACE;IACE,2DAA2D;EAC7D;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,iBAAiB;IACjB,eAAe;EACjB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":[".trainings-page {\n  max-width: 1500px;\n  margin: 40px auto 20px auto;\n}\n\n.trainings-admin-section {\n  margin-bottom: 32px;\n}\n\n.add-training-btn {\n  font-size: 16px;\n  padding: 14px 28px;\n  box-shadow: 0 2px 8px rgba(0, 102, 204, 0.2);\n}\n\n.training-form-container {\n  background: white;\n  border-radius: 12px;\n  padding: 16px 24px; /* 16px góra/dół, 24px lewo/prawo */\n  box-shadow: 0 2px 8px rgba(0,0,0,0.1);\n  margin-bottom: 24px;\n}\n\n.training-form-container h3 {\n  margin-bottom: 20px;\n  color: #333;\n}\n\n.training-form .form-row {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));\n  gap: 16px;\n  margin-bottom: 16px;\n}\n\n.training-form .form-group {\n  margin-bottom: 0;\n}\n\n.training-form textarea {\n  width: 100%;\n  padding: 12px;\n  border: 1px solid #ddd;\n  border-radius: 8px;\n  resize: vertical;\n  font-family: inherit;\n}\n\n.attachments-editor {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n  align-items: center;\n}\n\n.attachments-editor .attachment-item {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  background: #f0f4f8;\n  padding: 6px 12px;\n  border-radius: 20px;\n  font-size: 13px;\n}\n\n.attachment-editor-name {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.attachments-editor .attachment-item button {\n  background: none;\n  border: none;\n  cursor: pointer;\n  color: #999;\n  font-size: 14px;\n}\n\n.attachments-editor .attachment-item button:hover {\n  color: #dc3545;\n}\n\n.attachment-buttons {\n  display: flex;\n  gap: 8px;\n  margin-top: 8px;\n  width: 100%;\n}\n\n.form-actions {\n  display: flex;\n  gap: 12px;\n  margin-top: 20px;\n}\n\n.trainings-content {\n  display: flex;\n  flex-direction: column;\n  gap: 40px;\n}\n\n.trainings-section {\n  background: white;\n  border-radius: 16px;\n  padding: 32px;\n  box-shadow: 0 2px 12px rgba(0,0,0,0.08);\n}\n\n.section-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 28px;\n  padding-bottom: 20px;\n  border-bottom: 2px solid #f0f0f0;\n}\n\n.section-header h3 {\n  font-size: 24px;\n  color: #1a1a1a;\n  margin: 0;\n  font-weight: 600;\n}\n\n.section-count {\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  color: white;\n  padding: 8px 18px;\n  border-radius: 20px;\n  font-size: 14px;\n  font-weight: 600;\n}\n\n.archive-section .section-count {\n  background: linear-gradient(135deg, #868f96 0%, #596164 100%);\n}\n\n/* Single Column Layout */\n.trainings-grid {\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n}\n\n.trainings-grid.archive {\n  gap: 20px;\n}\n\n/* Modern Training Card - Full Width */\n.training-card {\n  background: white;\n  border-radius: 16px;\n  overflow: hidden;\n  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n  box-shadow: 0 2px 8px rgba(0,0,0,0.08);\n  border: 1px solid #e8e8e8;\n  position: relative;\n}\n\n.training-card:hover {\n  box-shadow: 0 8px 24px rgba(0,0,0,0.12);\n  transform: translateY(-4px);\n}\n\n.training-card.past {\n  opacity: 0.92;\n}\n\n.training-card.cancelled {\n  background: #fff8f8;\n  border-color: #ffcdd2;\n}\n\n.training-card.cancelled::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  height: 6px;\n  background: linear-gradient(135deg, #eb3349 0%, #f45c43 100%);\n  border-radius: 16px 16px 0 0;\n}\n\n/* Card Content Wrapper */\n.card-content-wrapper {\n  display: flex;\n  gap: 32px;\n  padding: 28px;\n}\n\n/* Logo Container */\n.training-logo-container {\n  flex: 0 0 200px;\n  height: 160px;\n  background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);\n  border-radius: 12px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  overflow: hidden;\n  box-shadow: 0 4px 12px rgba(0,0,0,0.08);\n}\n\n.training-logo-img {\n  max-width: 90%;\n  max-height: 90%;\n  object-fit: contain;\n}\n\n/* Main Content Area */\n.training-main-content {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n}\n\n/* Header Row */\n.training-header-row {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  gap: 20px;\n}\n\n.training-title-section {\n  flex: 1;\n}\n\n.training-title {\n  font-size: 24px;\n  font-weight: 700;\n  color: #1a1a1a;\n  margin: 0 0 12px 0;\n  line-height: 1.3;\n}\n\n.departments-tags {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n}\n\n.dept-tag {\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  color: white;\n  padding: 6px 14px;\n  border-radius: 16px;\n  font-size: 12px;\n  font-weight: 600;\n}\n\n/* Action Buttons */\n.training-actions {\n  display: flex;\n  gap: 8px;\n  flex-shrink: 0;\n}\n\n.action-btn {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  padding: 10px 16px;\n  border: none;\n  border-radius: 8px;\n  cursor: pointer;\n  font-size: 14px;\n  font-weight: 500;\n  transition: all 0.2s;\n}\n\n.action-btn .btn-text {\n  display: inline;\n}\n\n.edit-btn {\n  background: #e3f2fd;\n  color: #1976d2;\n}\n\n.edit-btn:hover {\n  background: #1976d2;\n  color: white;\n  transform: translateY(-2px);\n  box-shadow: 0 4px 8px rgba(25, 118, 210, 0.3);\n}\n\n.cancel-btn {\n  background: #fff3e0;\n  color: #f57c00;\n}\n\n.cancel-btn:hover {\n  background: #f57c00;\n  color: white;\n  transform: translateY(-2px);\n  box-shadow: 0 4px 8px rgba(245, 124, 0, 0.3);\n}\n\n.delete-btn {\n  background: #ffebee;\n  color: #d32f2f;\n}\n\n.delete-btn:hover {\n  background: #d32f2f;\n  color: white;\n  transform: translateY(-2px);\n  box-shadow: 0 4px 8px rgba(211, 47, 47, 0.3);\n}\n\n/* Meta Information Grid */\n.training-meta-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));\n  gap: 16px;\n  padding: 20px;\n  background: #f8f9fa;\n  border-radius: 12px;\n}\n\n.meta-item {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.meta-icon {\n  display: inline-flex;\n  color: #667eea;\n  flex-shrink: 0;\n}\n\n.meta-icon svg {\n  width: 24px;\n  height: 24px;\n  stroke-width: 1.8;\n}\n\n.meta-content {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n\n.meta-label {\n  font-size: 11px;\n  text-transform: uppercase;\n  color: #888;\n  font-weight: 600;\n  letter-spacing: 0.5px;\n}\n\n.meta-value {\n  font-size: 14px;\n  color: #333;\n  font-weight: 500;\n}\n\n/* Description Section */\n.training-description-section {\n  padding: 20px;\n  background: linear-gradient(135deg, #f5f7fa 0%, #e8eef5 100%);\n  border-left: 4px solid #667eea;\n  border-radius: 10px;\n  box-shadow: 0 2px 6px rgba(102, 126, 234, 0.1);\n}\n\n.description-heading {\n  font-size: 15px;\n  font-weight: 700;\n  color: #667eea;\n  margin: 0 0 12px 0;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.description-heading svg {\n  width: 19px;\n  height: 19px;\n  flex-shrink: 0;\n  stroke-width: 1.8;\n}\n\n.training-description {\n  color: #2d3748;\n  font-size: 15px;\n  line-height: 1.8;\n  margin: 0;\n  white-space: pre-wrap;\n}\n\n/* Resources Section */\n.training-resources {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n/* Primary Links */\n.primary-links {\n  display: flex;\n  gap: 12px;\n  flex-wrap: wrap;\n}\n\n.primary-link {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 14px 24px;\n  border-radius: 10px;\n  text-decoration: none;\n  font-size: 15px;\n  font-weight: 600;\n  transition: all 0.3s;\n  box-shadow: 0 2px 8px rgba(0,0,0,0.1);\n}\n\n.primary-link .link-arrow {\n  margin-left: 4px;\n  transition: transform 0.2s;\n}\n\n.primary-link:hover .link-arrow {\n  transform: translateX(4px);\n}\n\n.meeting-link {\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  color: white;\n}\n\n.meeting-link:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 6px 16px rgba(102, 126, 234, 0.4);\n}\n\n.recording-link {\n  background: linear-gradient(135deg, #f093fb 0%, #f5576c 100%);\n  color: white;\n}\n\n.recording-link:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 6px 16px rgba(245, 87, 108, 0.4);\n}\n\n/* Attachments Section */\n.attachments-section {\n  padding: 20px;\n  background: #f8f9fa;\n  border-radius: 12px;\n}\n\n.attachments-heading {\n  font-size: 14px;\n  font-weight: 600;\n  color: #333;\n  margin: 0 0 12px 0;\n}\n\n.attachments-list {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));\n  gap: 10px;\n}\n\n.attachment-item {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 12px 16px;\n  background: white;\n  border: 1px solid #e0e0e0;\n  border-radius: 8px;\n  text-decoration: none;\n  color: #333;\n  transition: all 0.2s;\n}\n\n.attachment-item:hover {\n  border-color: #667eea;\n  background: #f0f4ff;\n  transform: translateX(4px);\n}\n\n.attachment-icon {\n  display: inline-flex;\n  color: #667eea;\n}\n\n.attachment-name {\n  flex: 1;\n  font-size: 14px;\n  font-weight: 500;\n}\n\n.attachment-download {\n  color: #667eea;\n  font-weight: bold;\n}\n\n/* Empty State */\n.empty-state {\n  text-align: center;\n  padding: 60px 24px;\n  color: #666;\n}\n\n.empty-state.small {\n  padding: 32px;\n}\n\n.empty-icon {\n  font-size: 64px;\n  margin-bottom: 20px;\n}\n\n.trainings-page .empty-icon svg {\n  width: 64px;\n  height: 64px;\n  color: #667eea;\n  stroke-width: 1.5;\n}\n\n.empty-state h4 {\n  margin-bottom: 12px;\n  color: #333;\n  font-size: 20px;\n}\n\n.empty-state p {\n  margin-bottom: 20px;\n  font-size: 15px;\n}\n\n/* Responsive Design */\n@media (max-width: 900px) {\n  .card-content-wrapper {\n    flex-direction: column;\n  }\n\n  .training-logo-container {\n    flex: 0 0 auto;\n    width: 100%;\n    height: 200px;\n  }\n\n  .training-meta-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .training-header-row {\n    flex-direction: column;\n  }\n\n  .training-actions {\n    width: 100%;\n    justify-content: flex-start;\n  }\n\n  .action-btn .btn-text {\n    display: none;\n  }\n\n  .action-btn {\n    padding: 10px 12px;\n  }\n\n  .attachments-list {\n    grid-template-columns: 1fr;\n  }\n}\n\n/* Logo Section Styles */\n.logo-section {\n  margin-bottom: 20px;\n}\n\n.current-logo-preview {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  margin-bottom: 12px;\n  padding: 12px;\n  background: #f8f9fa;\n  border-radius: 8px;\n  border: 1px solid #e0e0e0;\n}\n\n.current-logo-preview img {\n  width: 80px;\n  height: 60px;\n  object-fit: cover;\n  border-radius: 6px;\n}\n\n.btn-remove-logo {\n  background: #ffeeee;\n  color: #dc3545;\n  border: 1px solid #dc3545;\n  padding: 6px 12px;\n  border-radius: 6px;\n  cursor: pointer;\n  font-size: 13px;\n  transition: all 0.2s;\n}\n\n.btn-remove-logo:hover {\n  background: #dc3545;\n  color: white;\n}\n\n.logo-options {\n  display: flex;\n  gap: 12px;\n  margin-bottom: 12px;\n  flex-wrap: wrap;\n}\n\n.upload-btn {\n  cursor: pointer;\n}\n\n.upload-btn:hover {\n  background: #0056b3;\n  color: white;\n}\n\n.logo-gallery {\n  background: #f8f9fa;\n  border: 1px solid #e0e0e0;\n  border-radius: 8px;\n  padding: 16px;\n  margin-bottom: 12px;\n}\n\n.logo-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(100px, 1fr));\n  gap: 12px;\n}\n\n.logo-item {\n  position: relative;\n  cursor: pointer;\n  border: 3px solid transparent;\n  border-radius: 8px;\n  overflow: hidden;\n  transition: all 0.2s;\n  aspect-ratio: 4/3;\n}\n\n.logo-item:hover {\n  border-color: #0066cc;\n  transform: scale(1.05);\n}\n\n.logo-item.selected {\n  border-color: #28a745;\n}\n\n.logo-item img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.no-logos {\n  color: #666;\n  text-align: center;\n  padding: 20px;\n  font-style: italic;\n}\n\n.manual-url-input {\n  margin-top: 8px;\n}\n\n.manual-url-input label {\n  display: block;\n  font-size: 13px;\n  color: #666;\n  margin-bottom: 4px;\n}\n\n.manual-url-input input {\n  width: 100%;\n  padding: 10px;\n  border: 1px solid #ddd;\n  border-radius: 6px;\n  font-size: 14px;\n}\n\n/* Multi-select Departments Styles */\n.departments-multiselect {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n  padding: 12px;\n  background: #f8f9fa;\n  border: 1px solid #ddd;\n  border-radius: 8px;\n}\n\n.department-checkbox {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 6px 12px;\n  background: white;\n  border: 1px solid #ddd;\n  border-radius: 20px;\n  cursor: pointer;\n  font-size: 13px;\n  transition: all 0.2s;\n}\n\n.department-checkbox:hover {\n  border-color: #0066cc;\n  background: #f0f7ff;\n}\n\n.department-checkbox.selected {\n  background: #0066cc;\n  border-color: #0066cc;\n  color: white;\n}\n\n.department-checkbox input {\n  display: none;\n}\n\n.selected-departments {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  margin-top: 8px;\n  padding: 8px 12px;\n  background: #e8f4fd;\n  border-radius: 6px;\n  font-size: 13px;\n}\n\n.selected-departments span {\n  flex: 1;\n  color: #0066cc;\n}\n\n.btn-clear-depts {\n  background: none;\n  border: none;\n  color: #dc3545;\n  cursor: pointer;\n  font-size: 12px;\n}\n\n.btn-clear-depts:hover {\n  text-decoration: underline;\n}\n\n.hint {\n  font-weight: normal;\n  color: #888;\n  font-size: 12px;\n}\n\n/* Modal Styles */\n.modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.5);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n}\n\n.modal-content {\n  background: white;\n  padding: 24px;\n  border-radius: 12px;\n  max-width: 400px;\n  width: 90%;\n  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.2);\n}\n\n.modal-content h4 {\n  margin: 0 0 8px 0;\n  color: #333;\n}\n\n.modal-hint {\n  color: #666;\n  font-size: 13px;\n  margin-bottom: 16px;\n}\n\n.modal-content input {\n  width: 100%;\n  padding: 12px;\n  border: 1px solid #ddd;\n  border-radius: 8px;\n  font-size: 14px;\n  margin-bottom: 16px;\n}\n\n.modal-content input:focus {\n  outline: none;\n  border-color: #0066cc;\n}\n\n.modal-field {\n  margin-bottom: 16px;\n}\n\n.modal-field label {\n  display: block;\n  font-weight: 500;\n  margin-bottom: 6px;\n  color: #333;\n  font-size: 13px;\n}\n\n.modal-field input,\n.modal-field select {\n  width: 100%;\n  padding: 10px 12px;\n  border: 1px solid #ddd;\n  border-radius: 8px;\n  font-size: 14px;\n  margin-bottom: 0;\n}\n\n.modal-field select {\n  background: white;\n  cursor: pointer;\n}\n\n.url-modal {\n  max-width: 450px;\n}\n\n.modal-actions {\n  display: flex;\n  gap: 12px;\n  justify-content: flex-end;\n}\n\n@media (max-width: 768px) {\n  .logo-grid {\n    grid-template-columns: repeat(auto-fill, minmax(80px, 1fr));\n  }\n\n  .departments-multiselect {\n    gap: 6px;\n  }\n\n  .department-checkbox {\n    padding: 4px 10px;\n    font-size: 12px;\n  }\n\n  .training-form .form-row {\n    grid-template-columns: 1fr;\n  }\n\n  .trainings-section {\n    padding: 20px;\n  }\n\n  .section-header h3 {\n    font-size: 20px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
